import { useQuery } from '@hooks/reactQuery';

import { getAvailableApprovalUnits } from '@api/assignApprovalUnit';

import { optionsFormattedWithIdName } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';
import { IApprovalUnit } from '@components/routes/AdminPanel/ManageApprovalUnits/interfaces';

import { AVAILABLE_APPROVAL_UNITS } from '@constants/queryKeys';

export const useQueryAvailableApprovalUnits = () => {
	const {
		data: availableApprovalUnits,
		isLoading: isLoadingAvailableApprovalUnits,
		isFetching: isFetchingAvailableApprovalUnits,
	} = useQuery<IApprovalUnit[], TSelectOption[]>({
		queryKey: [AVAILABLE_APPROVAL_UNITS],
		queryFn: getAvailableApprovalUnits,
		select: (options) => {
			return optionsFormattedWithIdName(options);
		},
	});

	return {
		availableApprovalUnits: availableApprovalUnits || [],
		isLoadingAvailableApprovalUnit: isLoadingAvailableApprovalUnits || isFetchingAvailableApprovalUnits,
	};
};
